// extracted by mini-css-extract-plugin
export var connectionButton = "_4g-1";
export var rightPanel = "_4g-3";
export var stepDescription = "_4g-2";
export var stepIcon = "_4g-0";